module.exports = __webpack_public_path__ + "static/media/vectors-11.aebd075d.png";